import { useQuery } from "@tanstack/react-query";
import UserApi from "../api/manageUserApi";

export const useUsersByRole = ({ role, page = 1, limit = 50, ofCompany, status, enable = true }) => {
  return useQuery({
    queryKey: ["usersByRole", role, page, limit, ofCompany, status],
    queryFn: () =>
      UserApi.fetchUserByRole({
        role,
        page,
        limit,
        ofCompany,
        status,
        populate: "role",
        fields: "name,role",
        selectPopulate: "name",
      }),
    keepPreviousData: true, // Keeps previous data while fetching new
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    enabled: enable,
  });
};
